import { fetchQuery, graphql } from "relay-runtime"
import {
  betterDocLookupQuery,
  betterDocLookupQuery$data,
} from "@/modules/admin/better-doc/services/__generated__/betterDocLookupQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query betterDocLookupQuery($identifier: String!) {
    de_betterDocLookup(identifier: $identifier) {
      sessions {
        sessionId
        partnerSessionId
        partnerPatientId
        progressNoteId
        isTestCase
        testCaseScenario
        recommendationDelivery
        insuranceCountry
        betterDocState
        createdAt
        createdBy
      }
      exchange {
        exchangeId
        operation
        createdBy
        httpMethod
        requestUri
        isTestCase
        hasUnexpectedResponse
        responseStatusCode
        durationMilliseconds
        startedAt
        outcome
        failureKind
      }
    }
  }
`

export type BetterDocLookupResult = betterDocLookupQuery$data["de_betterDocLookup"]

export const fetchBetterDocLookup = (identifier: string): Promise<BetterDocLookupResult | null> =>
  fetchQuery<betterDocLookupQuery>(RelayEnvironment, query, { identifier }, { fetchPolicy: "network-only" })
    .toPromise()
    .then((response) => response?.de_betterDocLookup ?? null)
